import * as commonScripts from '../common'

const cmpSocialShare = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element

    // If not in edit mode, then initialize the share links
    if (!commonScripts.util.isEditMode()) {
      _.component.querySelectorAll('.share-trigger').forEach(function (el) {
        const href = el.getAttribute('href')
        el.addEventListener('click', function (event) {
          event.stopPropagation()
          if (href !== null) {
            window.open(href, null, 'toolbar=0,location=0,status=0,menubar=0,scrollbars=1,resizable=1,width=500,height=600')
          }
        }, false)
      })
    }
  }

}

export default cmpSocialShare
